"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
function FindMeFollowMeIcon(props) {
    return (react_1.default.createElement(SvgIcon_1.default, __assign({}, props),
        react_1.default.createElement("path", { transform: "translate(12.066284, 12.088379) scale(1, -1) translate(-12.066284, -12.088379)", d: "M19.1003418,9.16088867 L19.1003418,10.9767578 L13,10.9767578 L13,9.16088867 L11,9.16088867 L11,10.9767578 L5.03222656,10.9767578 L5.03222656,9.16088867 C5.11767578,9.16088867 3.03222656,9.16088867 3.03222656,9.16088867 L3.03222656,10.9767578 L3.03222656,12.9767578 L5.03222656,12.9767578 L11,12.9767578 L11,15.0158691 L13,15.0158691 L13,12.9767578 L19.1003418,12.9767578 L21.1003418,12.9767578 L21.1003418,10.9767578 L21.1003418,9.16088867 L19.1003418,9.16088867 Z" }),
        react_1.default.createElement("circle", { cx: "12", cy: "5", r: "3" }),
        react_1.default.createElement("circle", { cx: "4", cy: "19", r: "3" }),
        react_1.default.createElement("circle", { cx: "12", cy: "19", r: "3" }),
        react_1.default.createElement("circle", { cx: "20", cy: "19", r: "3" })));
}
exports.default = FindMeFollowMeIcon;
